/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import { useResponsive } from '../hooks/useResponsive';
import { ExploreContext } from '../context/ExploreContext';

export const MapTypeSelect = () => {
  const { isMobile, isDesktop } = useResponsive();
  const { t } = useTranslation();

  const { base, setBase } = useContext(ExploreContext);

  const renderImage = () => {
    switch (base) {
      case 'osm-tiles':
        return 'ortho.jpeg';
      case 'ortho-tiles':
        return 'osm_picto.png';
      default:
        return;
    }
  };

  const handleBackgroundChange = () => {
    if (base === 'osm-tiles') {
      setBase('ortho-tiles');
    } else {
      setBase('osm-tiles');
    }
  };

  const style = {
    container: {
      position: 'absolute',
      left: isDesktop ? 5 : null,
      right: isDesktop ? null : 10,
      marginTop: '1em',
      zIndex: 100,
      alignItems: 'flex-end',
    },
    typeSelect: {
      display: 'flex',
      border: '0.3em solid',
      borderRadius: '1em',
      minWidth: isMobile ? '3em' : '4.3em',
      width: isMobile ? '3em' : '4.3em',
      height: isMobile ? '3em' : '4.3em',
      padding: 0,
      '&:hover': {
        color: '#666666',
        border: '0.3em solid',
      },
    },
  };

  return (
    <Box sx={style.container}>
      <Tooltip
        title={
          <p
            style={{
              fontSize: '1em',
            }}
          >
            {t(
              `layer.${
                base === 'osm-tiles' ? 'ortho_tiles_label' : 'osm_tiles_label'
              }`
            )}
          </p>
        }
        placement={isMobile ? 'top-end' : 'bottom-start'}
        arrow
      >
        <Button sx={style.typeSelect} onClick={handleBackgroundChange}>
          <img
            aria-hidden={true}
            src={renderImage()}
            style={{
              borderRadius: '.7em',
            }}
            width='100%'
            height='100%'
          />
        </Button>
      </Tooltip>
    </Box>
  );
};
